import styled from 'styled-components';

const BoxNamePpv = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 100%;

    & h2.name-ppv {
        font-size: 8px;
        font-weight: 500;
        margin: 0;
        padding: 0;
        margin-top: 2px;
        text-align: center;
    }
`;

// Render Nome PPV
function RenderNamePpv(match, keyMatch) {
    return (
        <BoxNamePpv className='box-name-ppv'>
            {/* ppv.ppv_descripion-name + ppv.date.split('-')[2] */}
            <h2 className='name-ppv'>{match.ppv.ppv_description.name} {match.ppv.date.split('-')[2]}</h2>
        </BoxNamePpv>
    )
}

export default RenderNamePpv;